<template>
  <div>
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir valider la supression de l'achat ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="accept()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="decline()">Non</vs-button>
        </div>
      </div>
    </vs-popup>

    <div class="w-full ml-2" :style="'text-align: center; max-height: ' + tableHeight +'px; overflow: auto;'">
        <div
          style="width: 388px;"
          class="vx-row mb-base w-full"
          v-for="societyCard in purchases.slice(0, lastPage)"
          :key="societyCard.contract_society_id"
        >
          <vx-card class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col w-1/6 pr-4">
                <div class="vx-row">
                  <vs-spacer />
                  <vs-avatar
                    style="width: 100px; height: 100px; border: 1px solid;"
                    :src="displaySocietyImage(societyCard.contract_society_id)"
                  />
                  <vs-spacer />
                </div>
                <div class="vx-row">
                  <vs-spacer /><h2>{{ getSocietyIdToName(societyCard.contract_society_id) }}</h2><vs-spacer />
                </div>
              </div>
              <div class="vx-col w-5/6">
                <div class="vx-row" v-for="(purchaseMonth, indexPM) in societyCard.purchasesByMonth" :key="indexPM">
                  <vx-card class="mb-2 w-full" v-if="purchaseMonth.length > 0">
                    <div class="vx-row mt-2 mr-2">
                      <h4>{{ societyCard.dates[indexPM].split('-').reverse().join('/') }}</h4>
                    </div>
                    <div class="mb-2" v-for="(purchase, indexP) in purchaseMonth" :key="indexP">
                      <hr v-if="indexP !== 0" style="color: grey;" />
                      <div class="vx-row mt-2">
                        <div class="vx-col" style="width: 50px;">
                          <vx-tooltip v-if="purchase.user_id" :text="getCollaboratorName(purchase.user_id)" position="top">
                            <vs-avatar
                              :src="getCollaboratorAvatar(purchase.user_id)"
                            />
                          </vx-tooltip>
                        </div>
                        <div class="vx-col" style="width: 55px;">
                          Contrat n°{{ purchase.contract_id }}
                        </div>
                        <div class="vx-col" style="width: 80px;">
                          {{ getProviderIdToName(purchase.users_id) }}
                        </div>
                        <div class="vx-col" style="width: 80px;">
                          {{ getServiceIdToName(purchase.service_id) }}
                        </div>
                        <div class="vx-col" style="width: 110px;">
                          {{ purchase.is_billable ? 'Facturable' : 'Pas Facturable' }}
                        </div>
                        <div class="vx-col w-auto" style="min-width: 200px;">
                          Commentaire : {{ purchase.commentary }}
                        </div>
                        <vs-spacer />
                        <div class="vx-col" style="width: 80px;">
                          <vx-tooltip text="Dupliquer l'achat" position="top">
                            <vs-button
                                size="large"
                                color="primary"
                                type="flat"
                                icon-pack="feather"
                                icon="icon-copy"
                                @click="renewPurchase(purchase.id)"
                            ></vs-button>
                          </vx-tooltip>
                        </div>
                        <div class="vx-col" style="width: 80px;">
                          <vx-tooltip text="Modifier" position="top">
                            <vs-button
                                size="large"
                                color="primary"
                                type="flat"
                                icon-pack="feather"
                                icon="icon-edit-2"
                                @click="updatePurchase(purchase)"
                            ></vs-button>
                          </vx-tooltip>
                        </div>
                        <div v-if="$acl.check('financesadmin')" class="vx-col" style="width: 80px;">
                          <vx-tooltip text="Effacer" position="top">
                            <vs-button
                                size="large"
                                color="danger"
                                type="flat"
                                icon-pack="feather"
                                icon="icon-trash-2"
                                @click="displayValidationPopup(purchase)"
                            ></vs-button>
                          </vx-tooltip>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
        <vs-button color="primary" @click="addPage" v-if="lastPage < purchases.length">Voir plus</vs-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import store from "@/store/store";
import sortingMixin from "@/mixins/sortingMixin.js";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import Purchase from "@/entities/Purchase";
import ValidationPopup from "@/components/popups/ValidationPopup";

export default {
	name: "PurchasesCardTable",
	props: {
		purchases: Array,
		societyimages: Array,
		// services: Array,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin, sortingMixin],
	components: {

	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null, // catching api error message
			showValidationPopup: false,
			purchaseToDelete: null,
			basicImgUrl: "task_default.png",
			societyImageList: [],
			displayedPurchaseCards: [],
			lastPage: 5
		};
	},
	created() {
		this.getAllSocieties();
		this.getAllProviders();
		this.getAllServices();
		this.getAllCollaborators();
		this.getAllCollaboratorsAvatar();
		// this.buildCardData(this.$props.purchases)
	},
	mounted() {
		store.dispatch("updateTableHeight", (this.windowHeigth-this.horizentalNavBarHeight)-this.filterCardHeight-(0.195*this.windowHeigth));
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch("updateTableHeight", (this.windowHeigth-this.horizentalNavBarHeight)-this.filterCardHeight-(0.195*this.windowHeigth));
			});
		});
	},
	updated(){
		this.$emit("stop-loader");
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		isFilterDown: () => {
			return store.state.isFilterDown;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		tableHeight: () => {
			return store.state.tableHeight;
		},
		societies: () => {
			return store.state.societies;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		}
	},
	watch: {
		isFilterDown: function(){
			store.dispatch("updateFilterCardHeight", document.getElementById("fliterCard").clientHeight);
			store.dispatch("updateTableHeight", (this.windowHeigth-this.horizentalNavBarHeight)-this.filterCardHeight-(0.195*this.windowHeigth));
		},
		purchases: function(data){
			//console.log("purchases watch");
			this.lastPage = 5;
			this.buildCardData(data);
		}
	},

	methods: {
		addPage(){
			this.lastPage+=5;
		},
		buildCardData(data){
			// SORT
			let purchaseData = this.sortByArgsName(data, ["contract_society_id", false], ["bought_at", true]);

			// GROUP
			let displayedPurchasesData = [];
			if(purchaseData.length > 0){
				let lastSocietyId = purchaseData[0].contract_society_id;

				let firstMonth = parseInt(purchaseData[0].bought_at.substring(5, 7));
				let firstYear = parseInt(purchaseData[0].bought_at.substring(0, 4));

				let secondMonth = firstMonth - 1 < 1 ? 12 : firstMonth - 1;
				let secondYear = firstMonth - 1 < 1 ? firstYear - 1 : firstYear;
				let thirdMonth = firstMonth - 2 < 1 ? 12 : firstMonth - 1;
				let thirdYear = firstMonth - 2 < 1 ? firstYear - 1 : firstYear;

				this.getSocietyImage(purchaseData[0].contract_society_id);

				displayedPurchasesData.push({
					contract_society_id: purchaseData[0].contract_society_id,
					society_image: this.getSocietyImage(purchaseData[0].contract_society_id),
					dates: [`${firstMonth}/${firstYear}`, `${secondMonth}/${secondYear}`, `${thirdMonth}/${thirdYear}`],
					firstMonthPurchase: [purchaseData[0]],
					secondMonthPurchase: [],
					thirdMonthPurchase: [],
				});
				for(let i = 1; i < purchaseData.length; i++){
					if(purchaseData[i].contract_society_id == lastSocietyId){
						if(parseInt(purchaseData[i].bought_at.substring(5, 7)) == firstMonth && parseInt(purchaseData[i].bought_at.substring(0, 4)) == firstYear){
							displayedPurchasesData[displayedPurchasesData.length - 1].firstMonthPurchase.push(purchaseData[i]);
						}
						else if(parseInt(purchaseData[i].bought_at.substring(5, 7)) == secondMonth && parseInt(purchaseData[i].bought_at.substring(0, 4)) == secondYear){
							displayedPurchasesData[displayedPurchasesData.length - 1].secondMonthPurchase.push(purchaseData[i]);
						}
						else if(parseInt(purchaseData[i].bought_at.substring(5, 7)) == thirdMonth && parseInt(purchaseData[i].bought_at.substring(0, 4)) == thirdYear){
							displayedPurchasesData[displayedPurchasesData.length - 1].thirdMonthPurchase.push(purchaseData[i]);
						}
					}
					else{
						lastSocietyId = purchaseData[i].contract_society_id;
						firstMonth = parseInt(purchaseData[i].bought_at.substring(5, 7));
						firstYear = parseInt(purchaseData[i].bought_at.substring(0, 4));
						secondMonth = firstMonth - 1 < 1 ? 12 : firstMonth - 1;
						secondYear = firstMonth - 1 < 1 ? firstYear - 1 : firstYear;
						thirdMonth = firstMonth - 2 < 1 ? 12 : firstMonth - 1;
						thirdYear = firstMonth - 2 < 1 ? firstYear - 1 : firstYear;

						this.getSocietyImage(purchaseData[i].contract_society_id);

						displayedPurchasesData.push({
							contract_society_id: purchaseData[i].contract_society_id,
							dates: [`${firstMonth}/${firstYear}`, `${secondMonth}/${secondYear}`, `${thirdMonth}/${thirdYear}`],
							firstMonthPurchase: [purchaseData[i]],
							secondMonthPurchase: [],
							thirdMonthPurchase: [],
						});
					}
				}
			}

			// ASSIGN
			this.displayedPurchaseCards = displayedPurchasesData;
		},

		getCollaboratorName(userId){
			let foundCollaborator = this.allCollaborators.find(collaborator => collaborator.id == userId);
			if(foundCollaborator) return foundCollaborator.firstname + " " + foundCollaborator.lastname;
			else return null;
		},

		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		getSocietyImage(societyId) {
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then(image => {
					if(image.data.length > 0){
						this.societyImageList.push(
							{
								id: societyId,
								image: image.data
							}
						);
					}
				})
				.catch(err => {
					//console.log(err);
				});
		},

		/**
		 * Fetch society by id
		 * @param {Number} societyId - The society id
		 */
		getSocietyById(societyId) {
			return this.societies.find(society => society.id == societyId);
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id){
			let service_name = "";
			let service = this.services.find(service => service.id == service_id);
			if(service != undefined && service.name != undefined){
				service_name = service.name;
			}
			return service_name;
		},

		getSocietyIdToName(society_id){
			let society_name = "";
			let society = this.societies.find(society => society.id == society_id);
			if(society != undefined && society.name != undefined){
				society_name = society.name;
			}
			return society_name;
		},

		getProviderIdToName(provider_id){
			let provider_name = "";
			let provider = this.providers.find(provider => provider.id == provider_id);
			if(provider != undefined && provider.society != undefined){
				provider_name = provider.society;
			}
			return provider_name;
		},

		formatDate(date_input){
			if(date_input && date_input.length > 10){
				return date_input.substring(0, 10);
			}
			else{
				return date_input;
			}
		},
		getAllServices(){
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties(){
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders(){
			this.$store.dispatch("getAllProviders");
		},

		getAllCollaborators() {
			this.$store.dispatch("getAllCollaborators");
		},

		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},

		deletePurchase(purchase){
			let purchaseToDelete = new Purchase(purchase);
			//console.log(purchase);
			if(purchaseToDelete.recurrence_id){
				purchaseToDelete.deleterc(purchaseToDelete.recurrence_id, (err, res) => {
					if(err) //console.log(err);
					if(res) {
						this.$emit("delete-line", purchase);
					}
				});
			}
			else{
				purchaseToDelete.delete(purchaseToDelete.id, (err, res) => {
					if(err) //console.log(err);
					if(res) {
						this.$emit("delete-line", purchase);
					}
				});
			}
		},

		displayValidationPopup(purchase){
			this.purchaseToDelete = purchase;
			this.showValidationPopup = true;
		},

		accept(){
			this.deletePurchase(this.purchaseToDelete);
			this.showValidationPopup = false;
		},

		decline(){
			this.purchaseToDelete = null;
			this.showValidationPopup = false;
		},

		updatePurchase(purchase){
			if(purchase.recurrence_id){
				let propsData = {
					propsData: {
						objToRedirect: purchase,
						title: "Voulez-vous modifier l'achat original ou l'achat récurrent ?",
						optionOneText: "L'achat original",
						optionTwoText: "L'achat récurrent",
						isActive: true,
					}
				};

				//console.log("propsData", propsData);
				//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
				let ComponentClass = Vue.extend(ValidationPopup);
				//console.log("ComponentClass");
				//console.log(ComponentClass);
				let validationPopup = new ComponentClass(propsData);
				validationPopup.$mount();
				validationPopup.$on("option-one", (purchase) => {
					this.updateMainPurchase(purchase);
				});
				validationPopup.$on("option-two", (purchase) => {
					this.updateRecurringPurchase(purchase);
				});
				this.$refs.popupContainer.appendChild(validationPopup.$el);
				//console.log("this.$refs.popupContainer");
				//console.log(this.$refs.popupContainer);
			}
			else{
				this.updateMainPurchase(purchase);
			}

		},

		displaySocietyImage(societyId){
			let foundImage = this.$props.societyimages.find(society => society.id == societyId);
			if(foundImage) return foundImage.image;
			else return this.basicImgUrl;
		},

		displaySocietyPopup(society) {
			//console.log("displaySocietyPopup", society);
			society.image = this.displaySocietyImage(society.id);
			this.$emit("show-society-popup", society);
		},
		displayContractPopup(contract){
			//console.log("displayContractPopup", contract);
			this.$emit("show-contract-popup", contract);
		},

		updateMainPurchase(purchase){
			//console.log("modify-purchase");
			this.$emit("modify-purchase", purchase);
		},

		updateRecurringPurchase(purchase){
			//console.log("modify-recurring");
			this.$emit("modify-recurring", purchase);
		},

		renewPurchase(purchaseId){
			this.$emit("renew-purchase", purchaseId);
		}
	}
};
</script>

<style scoped>
.hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
.center {
  justify-content: center;
}
</style>
